import type { ILegendItem } from "app/components/React/Legends/legendsTypes";
import { Legends as LegendsComponent } from "app/components/React/Legends/Legends";

type HighLevelMetricsComparisonChartLegendsProps = {
    legendItems: ILegendItem[];
    toggleLegendItem: (legendItem: ILegendItem) => void;
};

export const HighLevelMetricsComparisonChartLegends = ({
    legendItems,
    toggleLegendItem,
}: HighLevelMetricsComparisonChartLegendsProps) => {
    return (
        <LegendsComponent
            legendItems={legendItems}
            toggleSeries={toggleLegendItem}
        />
    );
};
